module.exports = __webpack_public_path__ + "static/media/BLUE.1e9e150d.png";